import React, { ComponentPropsWithoutRef, ElementType, ReactNode, useMemo } from 'react';
import { HTMLMotionProps, motion } from 'framer-motion';

export type TMotionComponentProps<T extends ElementType> = Omit<ComponentPropsWithoutRef<T>, 'children'> &
    Omit<HTMLMotionProps<'div'>, 'children'> & {
        component?: T;
        children?: ReactNode | ReactNode[];
    };

export const MotionComponent = <T extends ElementType>({ component, children, ...props }: TMotionComponentProps<T>) => {
    const Component = useMemo(() => {
        if (!component) {
            return motion.div;
        }
        return motion.create(component);
    }, [component]);

    return <Component {...props}>{children}</Component>;
};
